import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Paper, Button, CircularProgress, Grid, TextField } from '@material-ui/core';
import classnames from 'classnames';
import * as Yup from 'yup';
import { ErrorMessage, Form, Formik, useField } from 'formik';
import { AppContext } from '../../../AppContext';
import { createFieldManager } from '../../../services';

const styles = theme => ({
  paper: { padding: '24px', boxSizing: 'border-box' },
  formTextFieldInput: {
    padding: 15,
  },
  formTextFieldNotchedOutline: {
    '& fieldset': {
      borderColor: 'var(--jmi-blue) !important',
    },
  },
  errorMessage: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
  },
  actionButtonWrap: {
    width: '100%',
    textAlign: 'center',
    marginTop: 40,
  },
});

const FormTextField = withStyles(styles)(({ classes, inputProps, InputProps, label, ...props }) => {
  const { name, onChange } = props;
  const [field] = useField(props);

  return (
    <TextField
      name={name}
      label={label}
      autoComplete={name}
      margin="none"
      variant="outlined"
      fullWidth
      inputProps={{
        ...inputProps,
        className: classes.formTextFieldInput,
      }}
      InputProps={{
        ...InputProps,
        classes: {
          ...InputProps?.classes,
          focused: classes.formTextFieldNotchedOutline,
        },
      }}
      {...props}
      {...field}
      onChange={onChange || field.onChange}
    />
  );
});

const validationSchema = Yup.object({
  name: Yup.string().required('Required'),
  userName: Yup.string(),
});

export const FieldManagerUsersCreate = withRouter(
  withStyles(styles)(({ classes, history }) => {
    const { dispatch } = useContext(AppContext);

    const handleSubmit = async (values, { setSubmitting }) => {
      try {
        await createFieldManager({
          name: values.name,
          userName: values.userName || '',
          fieldManagerStateXref: [],
        });
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Field manager created!',
          },
        });
        history.push('/users/field-managers');
      } catch (error) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: error.message || 'Failed to create field manager',
          },
        });
      } finally {
        setSubmitting(false);
      }
    };

    return (
      <Paper className={classnames(classes.paper, 'border-left-green')} elevation={1}>
        <Formik
          initialValues={{ name: '', userName: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnMount
        >
          {formik => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormTextField name="name" label="Name" required />
                  <span className={classes.errorMessage}>
                    <ErrorMessage name="name" />
                  </span>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormTextField name="userName" label="Username" />
                  <span className={classes.errorMessage}>
                    <ErrorMessage name="userName" />
                  </span>
                </Grid>
              </Grid>

              <div className={classes.actionButtonWrap}>
                {formik.isSubmitting ? (
                  <CircularProgress size={24} />
                ) : (
                  <Button
                    type="submit"
                    size="medium"
                    color="primary"
                    variant="outlined"
                    disabled={!formik.isValid || formik.isSubmitting}
                  >
                    Save
                  </Button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </Paper>
    );
  }),
);
